import { useStore } from 'hooks/useStore';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

export const useBulkUpdate = (
  directData?: { GFC: number; Concept: string }[],
  indirectData?: { GFC: number; Concept: string }[]
) => {
  const {
    MSPlanStore: {
      bulkMSPlanupdateGFC,
      bulkUpdateDirectTodoGFC,
      bulkUpdateDirectCompletedGFC,
      bulkUpdateIndirectTodoGFC,
      bulkUpdateIndirectCompletedGFC,
      bulkUpdateGFCs,
      isMSPlanbulkUpdating,
      bulkUpdateMSPlan,
    },
  } = useStore();
  const [directConceptname, setDirectconceptname] = useState<string>('');
  const [indirectConceptname, setIndirectconceptname] = useState<string>('');
  const [directfilteredData, setDirectfilteredData] = useState(directData);
  const [indirectfilteredData, setIndirectfilteredData] = useState(indirectData);
  const [isDirectBulkUpdating, setIsDirectBulkUpdating] = useState<boolean>(false);
  const [isIndirectBulkUpdating, setIsIndirectBulkUpdating] = useState<boolean>(false);
  const [isBulkUpdating, setIsBulkUpdating] = useState<boolean>(false);

  useEffect(() => {
    // Update filtered data whenever the original data or search term changes
    if (directData && directData.length > 0) {
      setDirectfilteredData(
        directData?.filter(item =>
          item?.Concept?.toLowerCase()?.includes(directConceptname.toLowerCase())
        )
      );
    }

    if (indirectData && indirectData.length > 0) {
      setIndirectfilteredData(
        indirectData?.filter(item =>
          item?.Concept?.toLowerCase()?.includes(indirectConceptname.toLowerCase())
        )
      );
    }
  }, [directData, indirectData, directConceptname, indirectConceptname]);

  const getPlanningPeriod = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    return `${year}-${month}-01`;
  };

  const handleDirectBulkUpdate = async () => {
    try {
      setIsDirectBulkUpdating(true);
      const gfc_list = bulkUpdateDirectTodoGFC.map(item => item.GFC);
      await bulkUpdateMSPlan(gfc_list, 'Direct', getPlanningPeriod());
    } catch (error) {
      console.log('Error while bulk updating=> ', error);
      toast.error('Bulk Update failed');
    } finally {
      setIsDirectBulkUpdating(false);
    }
  };

  const handleIndirectBulkUpdate = async () => {
    try {
      setIsIndirectBulkUpdating(true);
      const gfc_list = bulkUpdateIndirectTodoGFC.map(item => item.GFC);
      await bulkUpdateMSPlan(gfc_list, 'Indirect', getPlanningPeriod());
    } catch (error) {
      console.log('Error while bulk updating=> ', error);
      toast.error('Bulk Update failed');
    } finally {
      setIsIndirectBulkUpdating(false);
    }
  };

  const handleBulkUpdate = async () => {
    try {
      setIsBulkUpdating(true);
      const gfc_list1 = bulkUpdateDirectTodoGFC.map(item => item.GFC);
      const gfc_list2 = bulkUpdateIndirectTodoGFC.map(item => item.GFC);
      await bulkUpdateMSPlan(gfc_list1.concat(gfc_list2), 'both', getPlanningPeriod());
    } catch (error) {
      console.log('Error while bulk updating=> ', error);
      toast.error('Bulk Update failed');
    } finally {
      setIsBulkUpdating(false);
    }
  };

  const handleDirectSearchChange = (e: any) => {
    e.preventDefault();
    setDirectconceptname(e.target.value);
  };

  const handleIndirectSearchChange = (e: any) => {
    e.preventDefault();
    setIndirectconceptname(e.target.value);
  };

  return {
    directConceptname,
    indirectConceptname,
    directfilteredData,
    indirectfilteredData,
    bulkMSPlanupdateGFC,
    bulkUpdateGFCs,
    bulkUpdateDirectTodoGFC,
    bulkUpdateDirectCompletedGFC,
    bulkUpdateIndirectTodoGFC,
    bulkUpdateIndirectCompletedGFC,
    isMSPlanbulkUpdating,
    isDirectBulkUpdating,
    isIndirectBulkUpdating,
    isBulkUpdating,
    setDirectconceptname,
    setIndirectconceptname,
    setDirectfilteredData,
    setIndirectfilteredData,
    handleDirectSearchChange,
    handleIndirectSearchChange,
    handleBulkUpdate,
    handleDirectBulkUpdate,
    handleIndirectBulkUpdate,
  };
};
